module.exports = __webpack_public_path__ + "img/detail-arrow@3x.e47ea886.png";